module.exports = __webpack_public_path__ + "img/checkout_chat_mail.5bff317.svg";